import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoMi: CultureInfo = {
  name: 'mi',
  displayName: 'Maori',
  iso3LanguageCode: 'mri',
  iso2LanguageCode: 'mi',
  ietfLanguageTag: 'mi',
  parent: null
};
